import './style.css';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import {TileWMS} from "ol/source";

function change(event) {
    let checkbox = event.target;
    let id = checkbox.id;
    map.getLayers().forEach(layer => {
        if (layer.id === id) {
            layer.setVisible(checkbox.checked);
        }
    });
}


const view = new View({
    center: [0, 0],
    zoom: 2,
    minZoom: 0,
    maxZoom: 10,
    projection: 'EPSG:4326',
});


const layers = [
    new TileLayer({
        source: new TileWMS({
            attributions: "<a href='https://www.bauhauserde.org'>Bauhaus Earth</a> and <a href='https://www.naturalearthdata.com'>Natural Earth</a>",
            attributionsCollapsible: false,
            url: 'https://beaver.bauhausearth-toolkit.com/geoserver/wms',
            params: {
                'LAYERS': 'supply:supply_map_ovr',
                'VERSION': '1.3.0',
                'FORMAT': 'image/png',
                'TILED': true,
                'TRANSPARENT': true,
            },
            serverType: 'geoserver',
        }),
    }),
    new TileLayer({
        source: new TileWMS({
            attributions: "<a href='https://www.bauhauserde.org'>Bauhaus Earth</a> and <a href='https://www.naturalearthdata.com'>Natural Earth</a>",
            attributionsCollapsible: false,
            url: 'https://beaver.bauhausearth-toolkit.com/geoserver/wms',
            params: {
                'LAYERS': 'supply:supply_map',
                'VERSION': '1.3.0',
                'FORMAT': 'image/png',
                'TILED': true,
                'TRANSPARENT': true,
            },
            serverType: 'geoserver',
        }),
    }),
];
const ids = ['supply_map_ovr', 'supply_map'];

for (let i = 0; i < layers.length; i++) {
    let layer = layers[i];
    layer.id = ids[i];
    let checkbox = document.getElementById(layer.id);
    checkbox.addEventListener('change', change);
    layer.setVisible(checkbox.checked);
}


const map = new Map({
    target: 'map',
    layers: layers,
    view: view,
    pixelRatio: 1,
});
